import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import PermissionGate from "../PermissionGate";
import CustomeButton from "../Button";
export default function EmptyDataView({
  Icon,
  Header,
  Description,
  buttonLabel,
  buttonHandler,
  type,
  resource,
  action = "modify",
  resourceAttr,
}) {
  return (
    <div
      className="flex flex-column justify-content-center align-items-center p-5 empty__data__view"
      data-testid="empty-data-view"
    >
      {Icon && (
        <div className="flex align-items-center p-3 empty__data__view--icon">
          {Icon}
        </div>
      )}
      {Header && (
        <p className="p-no-users-heading m-2 empty__data__view--header">
          {Header}
        </p>
      )}
      {Description && (
        <p className="p-no-users-sub-heading m-0 empty__data__view--description">
          {Description}
        </p>
      )}
      {buttonLabel && buttonHandler && (
        <PermissionGate
          resource={resource}
          action={action}
          resourceAttr={resourceAttr}
        >
          <CustomeButton
            label={buttonLabel}
            className="access-btn"
            icon="pi pi-plus"
            iconPos="right"
            onClick={buttonHandler}
            type={type}
          />
        </PermissionGate>
      )}
    </div>
  );
}
EmptyDataView.propTypes = {
  Icon: PropTypes.node,
  Header: PropTypes.string,
  Description: PropTypes.node,
  buttonLabel: PropTypes.string,
  buttonHandler: PropTypes.func,
  type: PropTypes.string,
  resource: PropTypes.string,
  action: PropTypes.string,
  resourceAttr: PropTypes.object,
};
